import Contributor from "./Contributor.js";
import { addOrUpdateContributor } from "../../Contributor.svelte";
import ProjectField from "./ProjectField.js";

let Project = {};

Project.myContributor = function(project, myUserId) {
  for (const contributor of project.contributors) {
    if (contributor.user && contributor.user.id == myUserId) {
      return contributor;
    }
  }
};

Project.userForContributorId = function(project, contributorId) {
  for (const contributor of project.contributors) {
    if (contributor.id == contributorId) {
      return contributor.user;
    }
  }
};

Project.hasFieldsConfigured = function(project) {
  if (project) {
    return (project.fields || [])
      .filter(f => !f.name || !ProjectField.isMetaField(f))
      .length
      ;
  }
};

Project.hasMetaField = function(project, metaName) {
  let result = null;
  (project.fields || []).forEach(field => {
    if (ProjectField.isMetaFieldType(field, metaName)) {
      result = true;
    }
  });
  return result;
};

Project.hasFields = function(project) {
  let result = false;
  (project.fields || []).forEach(field => {
    if (!ProjectField.isMetaField(field)) {
      result = true;
    }
  })
  return result
};

Project.fields = function(projectId) {
  return ProjectField.all(projectId)
};

// alias
Project.isLive = function(project) {
  return Project.hasMetaField(project, "LIVE");
};

Project.goLive = function(projectId) {
  return ProjectField.add(projectId, {
    name: "__LIVE__",
    description: "_",
    conditionDescription: "_",
    multiplier: 0,
    allowedAttachments: [],
    parameters: {arguments: []},
    formulaType: {
      id: "c34bb3ed-9409-469b-b06a-f43a57daa80a", // should be new or invalid
      name: "SYSTEM_META",
      type: "NONE",
      parameterTemplate: {arguments: []},
      operation: "NONE",
      variable: {
        name: "_",
        unit: "_",
        value: "_"
      }
    }
  });
};

// actually this is somewhat irrelevant.
// every project that is in a result that you are invited to
// has a contributor for you, albeit uninitialized.
// if you actually know a project ID from a query, you ought to
// have a contributor
Project.hasContributor = Project.myContributor;

Project.isOwner = function(project, myUserId) {
  let me = Project.myContributor(project, myUserId);
  return me && me.title == "Project Owner";
};

Project.isContributorInitialized = function(project, myUserId) {
  return Contributor.isInitialized(Project.myContributor(project, myUserId));
};

Project.initDefaultOwnerContributor = function(projectId, contributorId) {
  return addOrUpdateContributor(projectId, {
    title: "Project Owner",
    marketAnnualSalary: 50000,
    currency: "euro",
    commissionPercentage: 0,
    startDate:  (new Date()).toISOString(),
    id: contributorId
  })
};

export default Project;